export const validateReminderDays = (days) => {
  const val = parseInt(days, 10);
  if (Number.isNaN(val) || val < 1) return { valid: false, value: null };
  return { valid: true, value: val };
};

export const validateThreshold = (threshold) => {
  const val = parseInt(threshold, 10);
  if (Number.isNaN(val) || val < 0) return { valid: false, value: null };
  return { valid: true, value: val };
};




